import React from "react";

interface props {
  name: string;
  disabled?: boolean;
}
export default function Submitbtn({ name, disabled }: props) {
  return (
    <button
      type="submit"
      // className="submitBtn mb-3 w-100 font18 py-2"
      className={disabled  ? "btn btn-secondary searchButton font18 px-3":"submitBtn font18 px-3"}
      disabled={disabled}
    >
      {name}
    </button>
  );
}
